// extracted by mini-css-extract-plugin
module.exports = {"newsWrapper":"buildingNewsList_newsWrapper__15X6b","showMore":"buildingNewsList_showMore__4saVW","error":"buildingNewsList_error__xWOEe"};